// extracted by mini-css-extract-plugin
var _1 = "declined-warning-box__IxkVm";
export { _1 as "declinedWarningBox" }
